import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from '../redux/hooks';
import { openLogin, openShoppingCart, openWishlist } from '../redux/slices/modalSlice';
import CustomSVG from './CustomSVG';
import { useNavigate } from 'react-router-dom';

const NavigationContainer = styled.div`
  width: 140px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-area: navigation;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 100%;
  cursor: pointer;
`;

const IconBadge = styled.span<{ count: number }>`
  position: relative;

  &::after {
    content: '${props => props.count}';
    display: ${props => props.count > 0 ? 'flex' : 'none'};
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -5px;
    right: -10px;
    width: 18px;
    height: 18px;
    background-color: #e74c3c;
    color: white;
    border-radius: 50%;
    font-size: 10px;
    font-weight: bold;
  }
`;

const Navigation: React.FC = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const favorites = useSelector((state) => state.favorites.items.length);
  const cartItems = useSelector((state) => state.cart.items.length);
  const { accessToken, isAuthChecked } = useSelector((state) => state.auth);

  const memoizedFavorites = useMemo(() => favorites, [favorites]);
  const memoizedCartItems = useMemo(() => cartItems, [cartItems]);

  const handleProfileClick = () => {
    if (!isAuthChecked) return null;

    if (accessToken) {
      navigate('/profile');
    } else {
      dispatch(openLogin());
    }
  };

  return (
    <NavigationContainer>
      <IconContainer onClick={() => dispatch(openWishlist())}>
        <IconBadge count={memoizedFavorites}>
          <CustomSVG
            src={`${process.env.PUBLIC_URL}/media/Bookmark.svg`}
            width="32px"
            height="32px"
            color="#3B6255"
          />
        </IconBadge>
      </IconContainer>

      <IconContainer onClick={() => dispatch(openShoppingCart())}>
        <IconBadge count={memoizedCartItems}>
          <CustomSVG
            src={`${process.env.PUBLIC_URL}/media/CartGreen.svg`}
            width="32px"
            height="32px"
            color="#3B6255"
          />
        </IconBadge>
      </IconContainer>

      <IconContainer onClick={handleProfileClick}>
        <CustomSVG
          src={`${process.env.PUBLIC_URL}/media/ProfileIcon.svg`}
          width="32px"
          height="32px"
          color="#000"
        />
      </IconContainer>
    </NavigationContainer>
  );
});

export default Navigation;
